import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {

  @Input() id: string;
  @Input() canIclose: boolean = true;
  @Input() large: boolean = false;
  @Input() ultralarge: boolean = false;
  @Input() dragable: boolean = true;
  @Input() resizable: boolean = true;
  @Output() modalHide: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {

    if (this.dragable == true) {
      $(".modal-header").on("mousedown", function (mousedownEvt) {
        var $draggable = $(this);
        var x = mousedownEvt.pageX - $draggable.offset().left,
          y = mousedownEvt.pageY - $draggable.offset().top;
        $("body").on("mousemove.draggable", function (mousemoveEvt) {
          $draggable.closest(".modal-dialog").offset({
            "left": mousemoveEvt.pageX - x,
            "top": mousemoveEvt.pageY - y
          });
        });
        $("body").one("mouseup", function () {
          $("body").off("mousemove.draggable");
        });
        $draggable.closest(".modal").one("bs.modal.hide", function () {
          $("body").off("mousemove.draggable");
        });
      });

      $(".modal-dialog").draggable();
    }

    if (this.resizable == true) {
      $(".modal-content").resizable({
        //alsoResize: ".modal-dialog",
        minHeight: 150,
        minWidth: 400
      });

      $('.modal').on('show.bs.modal', function () {
        $(this).find(".modal-body" ).css({
          'max-height': '100%'
        });
      });

    }
  }

}
